module.exports = __webpack_public_path__ + "static/media/maxDailyLogin_120_150.a51e9a8b.png";